import { ChevronLeft, ChevronRight } from "lucide-react";

// Server-side pagination control. `page` is 0-indexed.
export default function Pagination({ page, pageSize, total, onPage }) {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if ((total || 0) <= pageSize) return null;
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min(total, (page + 1) * pageSize);
  const btn = "inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-[rgba(28,28,30,0.15)] text-agri-ink hover:bg-black/5 disabled:opacity-40 disabled:pointer-events-none transition-colors";
  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <div className="text-agri-ink-2 tabular-nums">Showing {from}–{to} of {total}</div>
      <div className="flex items-center gap-2">
        <button className={btn} disabled={page <= 0} onClick={() => onPage(page - 1)}>
          <ChevronLeft size={15} /> Prev
        </button>
        <span className="text-agri-ink-2 tabular-nums px-1">Page {page + 1} / {pages}</span>
        <button className={btn} disabled={page >= pages - 1} onClick={() => onPage(page + 1)}>
          Next <ChevronRight size={15} />
        </button>
      </div>
    </div>
  );
}
